
import * as ipxStaticRuntime$eSjFeVJMpTrMwpaCl_45e2OlkP9lGpFYyQdJ_9AuvhlXA from 'C:/Users/brend/GIT/kas-warranty/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipxStatic']: { provider: ipxStaticRuntime$eSjFeVJMpTrMwpaCl_45e2OlkP9lGpFYyQdJ_9AuvhlXA, defaults: {} }
}
        